
<template>
    <!-- Main component  -->
    <div v-if="data" class="tc" v-bind:id="id"
        @mousedown="mousedown" @mouseleave="mouseleave"
         :style="{
            color: this.chart_props.colors.text,
            font: this.font_comp,
            width: this.width+'px',
            height: this.height+'px'}">
        <toolbar v-if="toolbar"
            ref="toolbar"
            v-on:custom-event="custom_event"
            v-bind="chart_props"
            v-bind:config="chart_config">
        </toolbar>

        <widgets v-if="controllers.length"
            ref="widgets"
            :map="ws" :width="width" :height="height"
            :tv="this" :dc="data">
        </widgets>
        <chart :key="reset"
            ref="chart"
            v-bind="chart_props"
            v-bind:tv_id="id"
            v-bind:config="chart_config"
            v-on:custom-event="custom_event"
            v-on:range-changed="range_changed"
            v-on:reset-chart="reset_chart"
            v-on:legend-button-click="legend_button">
        </chart>
        <div class="control_bar">
            <chart-button class="btn_on_large_screen" index="zoom_out" v-on:chart-button-click="zoomOut" />
            <chart-button class="btn_on_large_screen" index="zoom_in" v-on:chart-button-click="zoomIn" />
            <span class="spacer" />
            <chart-button class="btn_on_large_screen" index="scroll_left" v-on:chart-button-click="scrollLeft" />
            <chart-button class="btn_on_large_screen" index="scroll_right" v-on:chart-button-click="scrollRight" />
            <span class="spacer" />
            <chart-button class="btn_on_all_screen" index="reset_chart" v-on:chart-button-click="reset_chart" />
        </div>
        <div class="watermark">
            {{this.$props.titleTxt}} {{this.$props.titleTxt ? ", " + this.$props.tf : ""}}
        </div>
        <chart-button class="chart_logo_wrapper" index="logo" label="TradingCandle" v-on:chart-button-click="logo_expand" />
        <StrategyExecutionLayer :records="strategyRecords" :plots="strategyPlots" :times="strategyTimes" :get-layout="getChartLayout" :selected-id="strategySelectedId" @strategy-event="$emit('strategy-event',$event)" />
        <alert-lines-layer
            :alerts="$props.alerts"
            :get-layout="getChartLayout"
            :get-cursor="getChartCursor"
            :width="width"
            :height="height"
            @alert-action="onAlertAction"
        />
        <transition name="tcjs-drift">
            <the-tip :data="tip" v-if="tip"
                @remove-me="tip = null"/>
        </transition>
        <drawing-quick-bar
            :visible="editPopup.visible && !editPopup.expanded"
            :settings="editPopup.settings"
            :tool-name="editPopup.toolName"
            :pos-x="editPopup.x"
            :pos-y="editPopup.y"
            @change-settings="onEditSettings"
            @delete-tool="onDeleteTool"
            @expand="editPopup.expanded = true"
        />
        <drawing-edit-popup
            :visible="editPopup.visible && editPopup.expanded"
            :cloud-drawing="editPopup.visible?cloudDrawing:null"
            :anchor-interval="$refs.chart?.$props.ib?1:($refs.chart?.interval || 1)"
            @remote-drawing="applyCloudDrawing"
            :settings="editPopup.settings"
            :tool-name="editPopup.toolName"
            :pos-x="editPopup.x"
            :pos-y="editPopup.y + 40"
            @change-settings="onEditSettings"
            @delete-tool="onDeleteTool"
            @clone-tool="onCloneTool"
            @load-profile="(uuid,tf)=>$emit('load-profile',uuid,tf)"
            @close="editPopup.expanded = false"
        />
    </div>
    <div v-else>
    </div>
</template>

<script>

import Const from './stuff/constants.js'
import Chart from './components/Chart.vue'
import ChartButton from './components/ChartButton.vue'
import Toolbar from './components/Toolbar.vue'
import Widgets from './components/Widgets.vue'
import TheTip from './components/TheTip.vue'
import DrawingEditPopup from './components/DrawingEditPopup.vue'
import DrawingQuickBar from './components/DrawingQuickBar.vue'
import AlertLinesLayer from './components/AlertLinesLayer.vue'
import StrategyExecutionLayer from './components/StrategyExecutionLayer.vue'
import XControl from './mixins/xcontrol.js'

export default {
    name: 'tc',
    components: {
        Chart, Toolbar, Widgets, TheTip, ChartButton, DrawingEditPopup, DrawingQuickBar, AlertLinesLayer, StrategyExecutionLayer
    },
    mixins: [ XControl ],
    props: {
        active: { type:Boolean, default:true },
        titleTxt: {
            type: String,
            default: ''
        },
        tf: {
            type: String,
            default: ''
        },
        exchange: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: 'tc-js'
        },
        resetBtn: {
            type: String,
            default: 'reset'
        },
        width: {
            type: Number,
            default: 800
        },
        height: {
            type: Number,
            default: 421
        },
        colorTitle: {
            type: String,
            default: '#474D4A'
        },
        colorBack: {
            type: String,
            default: '#121826'
        },
        colorGrid: {
            type: String,
            default: '#2f3240'
        },
        colorText: {
            type: String,
            default: '#dedddd'
        },
        colorTextHL: {
            type: String,
            default: '#fff'
        },
        colorScale: {
            type: String,
            default: '#e6e8eb'
        },
        colorCross: {
            type: String,
            default: '#8091a0'
        },
        colorCandleUp: {
            type: String,
            default: '#23a776'
        },
        colorCandleDw: {
            type: String,
            default: '#e54150'
        },
        colorWickUp: {
            type: String,
            default: '#23a77688'
        },
        colorWickDw: {
            type: String,
            default: '#e5415088'
        },
        colorWickSm: {
            type: String,
            default: 'transparent' // deprecated
        },
        colorVolUp: {
            type: String,
            default: '#79999e42'
        },
        colorVolDw: {
            type: String,
            default: '#ef535042'
        },
        colorPanel: {
            type: String,
            default: '#565c68'
        },
        colorTbBack: {
            type: String
        },
        colorTbBorder: {
            type: String,
            default: '#8282827d'
        },
        colors: {
            type: Object
        },
        font: {
            type: String,
            default: Const.ChartConfig.FONT
        },
        toolbar: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            required: true
        },
        // Your overlay classes here
        overlays: {
            type: Array,
            default: function () { return [] }
        },
        // Overwrites ChartConfig values,
        // see constants.js
        chartConfig: {
            type: Object,
            default: function () { return {} }
        },
        legendButtons: {
            type: Array,
            default: function () { return [] }
        },
        indexBased: {
            type: Boolean,
            default: false
        },
        extensions: {
            type: Array,
            default: function () { return [] }
        },
        xSettings: {
            type: Object,
            default: function () { return {} }
        },
        skin: {
            type: String // Skin Name
        },
        timezone: {
            type: Number,
            default: 0
        },
        // Price alerts to draw as draggable lines on the main chart.
        // Plain data from the alert API, independent of the DataCube -
        // see AlertLinesLayer.vue and workspace/mixin.js's
        // workspaceAllAlerts / onChartAlertAction.
        strategyRecords: {type:Array,default:()=>[]},
        strategySelectedId: String,
        strategyPlots: Object,
        strategyTimes: Array,
        alerts: {
            type: Array,
            default: function () { return [] }
        }
    },
    computed: {
        cloudDrawing(){
            const dc=this.$props.data,uuid=this.editPopup.settings?.$uuid,ov=['onchart','offchart'].flatMap(side=>dc?.data?.[side] || []).find(o=>o.settings?.$uuid===uuid);
            if(!ov)return null;const settings=JSON.parse(JSON.stringify(ov.settings)),chart=this.$refs.chart;
            if(chart?.$props.ib){for(const key of Object.keys(settings))if(/^p\d+$/.test(key))settings[key][0]=chart.ti_map.i2t(settings[key][0]);if(settings.path)settings.path=settings.path.map(p=>[chart.ti_map.i2t(p[0]),p[1]])}
            return {type:ov.type,name:ov.name,symbol:this.$props.titleTxt,timeframe:this.$props.tf,settings};
        },
        // Copy a subset of TC props
        chart_props() {
            let offset = this.$props.toolbar ?
                this.chart_config.TOOLBAR : 0
            let chart_props = {
                title_txt: this.$props.titleTxt,
                active: this.$props.active,
                tf: this.$props.tf,
                exchange: this.$props.exchange,
                overlays: this.$props.overlays.concat(this.mod_ovs),
                data: this.decubed,
                width: this.$props.width - offset,
                height: this.$props.height,
                font: this.font_comp,
                buttons: this.$props.legendButtons,
                toolbar: this.$props.toolbar,
                ib: this.$props.indexBased || this.index_based || false,
                colors: Object.assign({}, this.$props.colors ||
                    this.colorpack),
                skin: this.skin_proto,
                timezone: this.$props.timezone
            }
            this.parse_colors(chart_props.colors)
            return chart_props
        },
        chart_config() {
            return Object.assign({},
                Const.ChartConfig,
                this.$props.chartConfig,
            )
        },
        decubed() {
            // Reading chart data must not attach/reassign its owning view.
            // A replaced view can still be referenced by the shared toolbar's
            // computed value. Attaching here made old/new views steal the same
            // DataCube repeatedly during Vue 3 computed invalidation.
            return this.$props.data?.data
        },
        index_based() {
            const base = this.$props.data
            if (!base) {
                return false
            }
            if (base.chart) {
                return base.chart.indexBased
            }
            else if (base.data) {
                return base.data.chart.indexBased
            }
            return false
        },
        mod_ovs() {
            let arr = []
            for (var x of this.$props.extensions) {
                arr.push(...Object.values(x.overlays))
            }
            return arr
        },
        font_comp() {
            return this.skin_proto && this.skin_proto.font ?
                this.skin_proto.font : this.font
        }
    },
    data() {
        return {
            reset: 0,
            tip: null,
            editPopup: {
                visible: false,
                expanded: false, // false = compact quick bar only, true = full settings panel
                settings: {},
                toolName: '',
                x: 200,
                y: 100,
                ovId: null,     // datacube overlay id (e.g. 'onchart.0')
                gridId: null,
                layerId: null
            }
        }
    },
    beforeMount() {
        this.$props.data?.init_tvjs(this)
    },
    watch: {
        data(next, previous) {
            if (next === previous) return
            if (previous && previous !== next && previous.tv === this) previous.before_destroy()
            next?.init_tvjs(this)
            this.ctrllist()
        },
    },
    beforeDestroy() {
        if (this.data?.tv === this) this.custom_event({ event: 'before-destroy' })
        this.ctrl_destroy()
        if (this._closePopupTimer) {
            clearTimeout(this._closePopupTimer)
        }
    },
    methods: {
        // TODO: reset extensions?
        resetChart(resetRange = true) {
            this.reset++
            let range = this.getRange()
            if (!resetRange && range[0] && range[1]) {
                this.$nextTick(() => this.setRange(...range))
            }
            this.$nextTick(() => this.custom_event({
                event: 'chart-reset', args: []
            }))
        },
        goto(t) {
            // TODO: limit goto & setRange (out of data error)
            if (this.chart_props.ib) {
                const ti_map = this.$refs.chart.ti_map
                t = ti_map.gt2i(t, this.$refs.chart.ohlcv)
            }
            //this.$refs.chart.goto(t)
        },
        scrollLeft() {
            let range = this.getRange()
            let diff = range[1] - range[0]
            if (range[0] && range[1]) {
                range[0] = range[0] - (diff / 4)
                range[1] = range[1] - (diff / 4)
                this.$nextTick(() => this.setRange(...range))
            }
            this.$nextTick(() => this.custom_event({
                event: 'chart-reset', args: []
            }))
        },
        scrollRight() {
            let range = this.getRange()
            let diff = range[1] - range[0]
            if (range[0] && range[1]) {
                range[0] = range[0] + (diff / 4)
                range[1] = range[1] + (diff / 4)
                this.$nextTick(() => this.setRange(...range))
            }
            this.$nextTick(() => this.custom_event({
                event: 'chart-reset', args: []
            }))
        },
        zoomIn() {
            let range = this.getRange()
            let diff = range[1] - range[0]
            if (range[0] && range[1]) {
                range[0] = range[0] + (diff / 4)
                if (range[0] > range[1])
                    range[0] = range[1] - (diff / 4)
                this.$nextTick(() => this.setRange(...range))
            }
            this.$nextTick(() => this.custom_event({
                event: 'chart-reset', args: []
            }))
        },
        zoomOut() {
            let range = this.getRange()
            let diff = range[1] - range[0]
            if (range[0] && range[1]) {
                range[0] = range[0] - (diff / 4)
                this.$nextTick(() => this.setRange(...range))
            }
            this.$nextTick(() => this.custom_event({
                event: 'chart-reset', args: []
            }))
        },
        setRange(t1, t2) {
            if (this.chart_props.ib) {
                const ti_map = this.$refs.chart.ti_map
                const ohlcv = this.$refs.chart.ohlcv
                t1 = ti_map.gt2i(t1, ohlcv)
                t2 = ti_map.gt2i(t2, ohlcv)
            }
            this.$refs.chart.setRange(t1, t2)
        },
        getRange() {
            if (!this.$refs.chart) return [0, 0]
            if (this.chart_props.ib) {
                const ti_map = this.$refs.chart.ti_map
                // Time range => index range
                return this.$refs.chart.range
                    .map(x => ti_map.i2t(x))
            }
            return this.$refs.chart.range
        },
        getCursor() {

            let cursor = this.$refs.chart.cursor
            if (this.chart_props.ib) {
                const ti_map = this.$refs.chart.ti_map
                let copy = Object.assign({}, cursor)
                copy.i = copy.t
                copy.t = ti_map.i2t(copy.t)
                return copy
            }
            return cursor
        },
        showTheTip(text, color = "orange") {
            this.tip = { text, color }
        },
        legend_button(event) {
            this.custom_event({
                event: 'legend-button-click', args: [event]
            })
        },
        reset_chart(event) {
            this.resetChart(true)
        },
        logo_expand(event) {
            let button = event.target
        },
        custom_event(d) {
            if ('args' in d) {
                this.$emit(d.event, ...d.args)
            } else {
                this.$emit(d.event)
            }
            let data = this.$props.data
            let ctrl = this.controllers.length !== 0
            if (ctrl) this.pre_dc(d)
            if (data && data.tv) {
                // If the data object is DataCube
                data.on_custom_event(d.event, d.args)
            }
            if (ctrl) this.post_dc(d)

            // Show / hide the drawing edit popup
            if (d.event === 'object-selected') {
                this.onObjectSelected(d.args || [])
            }
            // When a drawing is finished, show the edit popup for it
            if (d.event === 'drawing-mode-off') {
                // Small delay to ensure the drawing state is fully updated
                setTimeout(() => {
                    this.showPopupForSelected()
                }, 100)
            }
            if (d.event === 'tool-selected') {
                // Close popup when switching tools
                this.closeEditPopup()
            }
            if (d.event === 'remove-tool') {
                // Close popup when a drawing is deleted via keyboard
                this.closeEditPopup()
            }
        },
        range_changed(r) {
            if (this.chart_props.ib) {
                const ti_map = this.$refs.chart.ti_map
                r = r.map(x => ti_map.i2t(x))
            }
            this.$emit('range-changed', r)
            this.custom_event(
                {event: 'range-changed', args: [r]}
            )
            if (this.onrange) this.onrange(r)
        },
        set_loader(dc) {
            this.onrange = r => {
                let pf = this.chart_props.ib ? '_ms' : ''
                let tf = this.$refs.chart['interval' + pf]
                dc.range_changed(r, tf)
            }
        },
        parse_colors(colors) {
            for (var k in this.$props) {
                if (k.indexOf('color') === 0 && k !== 'colors') {
                    let k2 = k.replace('color', '')
                    k2 = k2[0].toLowerCase() + k2.slice(1)
                    if (colors[k2]) continue
                    colors[k2] = this.$props[k]
                }
            }
        },
        mousedown() {
            this.$refs.chart.activated = true
        },
        mouseleave() {
            this.$refs.chart.activated = false
        },
        // --- Drawing edit popup ---
        onObjectSelected(args) {
            // Cancel any pending close so a quick
            // deselect→reselect doesn't kill the popup
            if (this._closePopupTimer) {
                clearTimeout(this._closePopupTimer)
                this._closePopupTimer = null
            }

            if (!args || !args.length) {
                this._closePopupTimer = setTimeout(() => {
                    this.editPopup.visible = false
                    this._closePopupTimer = null
                }, 80)
                return
            }
            // The overlay mixin's custom_event wraps the original
            // emitted args as the first element, then appends
            // grid_id, layer_id, and $uuid.
            // So args = [originalArray, grid_id, layer_id, uuid]
            // where originalArray = [parent, type, uuid]
            // We need the uuid which is the last element appended
            // by the overlay mixin.
            let uuid = args[args.length - 1]
            let gridId = args.length > 2 ? args[args.length - 3] : args[0]
            let layerId = args.length > 2 ? args[args.length - 2] : args[1]
            if (!uuid) {
                this._closePopupTimer = setTimeout(() => {
                    this.editPopup.visible = false
                    this._closePopupTimer = null
                }, 80)
                return
            }
            // Find the overlay and its datacube path
            let dc = this.$props.data
            let ov = null
            let ovId = null
            if (dc && dc.data) {
                let idx = (dc.data.onchart || []).findIndex(
                    x => x.settings && (
                        x.settings.$uuid === uuid ||
                        (x.id && x.id.includes(uuid)) ||
                        (x.name && x.name.includes(uuid))
                    )
                )
                if (idx >= 0) {
                    ov = dc.data.onchart[idx]
                    ovId = `onchart.${idx}`
                } else {
                    idx = (dc.data.offchart || []).findIndex(
                        x => x.settings && (
                            x.settings.$uuid === uuid ||
                            (x.id && x.id.includes(uuid)) ||
                            (x.name && x.name.includes(uuid))
                        )
                    )
                    if (idx >= 0) {
                        ov = dc.data.offchart[idx]
                        ovId = `offchart.${idx}`
                    }
                }
            }
            if (!ov || !ov.settings) {
                this.closeEditPopup()
                return
            }
            // Allow 'finished' or 'wip' state (state may not have
            // propagated reactively yet when emitted right after set_state)
            if (ov.settings.$state && ov.settings.$state !== 'finished' && ov.settings.$state !== 'wip') return

            // Position the popup near the cursor
            let cursor = this.getCursor()
            let chart = this.$refs.chart
            let layout = chart && chart._layout
            let px = 200, py = 100
            if (layout && layout.grids && layout.grids[0]) {
                if (cursor && cursor.x !== undefined) {
                    px = cursor.x + (this.toolbar ? this.chart_config.TOOLBAR : 0) + 20
                    py = cursor.y + 20
                } else {
                    px = layout.grids[0].width / 2
                    py = layout.grids[0].height / 3
                }
            }
            px = Math.max(60, Math.min(px, this.width - 240))
            py = Math.max(20, Math.min(py, this.height - 200))

            this.editPopup = {
                visible: true,
                settings: Object.assign({}, ov.settings),
                toolName: ov.name || ov.type || 'Drawing',
                x: px,
                y: py,
                ovId: ovId,
                gridId: gridId,
                layerId: layerId
            }
        },
        showPopupForSelected() {
            let dc = this.$props.data
            if (!dc || !dc.data) return
            let selected = dc.data.selected
            if (!selected) return
            // Find the overlay by $uuid or by id/name (datacube stores layer_id)
            let ov = null
            let ovId = null
            let idx = (dc.data.onchart || []).findIndex(
                x => x.settings && (
                    x.settings.$uuid === selected ||
                    (x.id && x.id.includes(selected)) ||
                    (x.name && x.name.includes(selected))
                )
            )
            if (idx >= 0) {
                ov = dc.data.onchart[idx]
                ovId = `onchart.${idx}`
            } else {
                idx = (dc.data.offchart || []).findIndex(
                    x => x.settings && (
                        x.settings.$uuid === selected ||
                        (x.id && x.id.includes(selected)) ||
                        (x.name && x.name.includes(selected))
                    )
                )
                if (idx >= 0) {
                    ov = dc.data.offchart[idx]
                    ovId = `offchart.${idx}`
                }
            }
            if (!ov || !ov.settings) return
            if (ov.settings.$state !== 'finished') return

            // Position near center-right of chart
            let chart = this.$refs.chart
            let layout = chart && chart._layout
            let px = 200, py = 100
            if (layout && layout.grids && layout.grids[0]) {
                px = layout.grids[0].width - 240
                py = 80
            }
            px = Math.max(60, Math.min(px, this.width - 240))
            py = Math.max(20, Math.min(py, this.height - 200))

            this.editPopup = {
                visible: true,
                settings: Object.assign({}, ov.settings),
                toolName: ov.name || ov.type || 'Drawing',
                x: px,
                y: py,
                ovId: ovId,
                gridId: null,
                layerId: null
            }
        },
        applyCloudDrawing(drawing,metadata){
            if(drawing.symbol!==this.$props.titleTxt){this.showTheTip('Open '+drawing.symbol+' before applying this drawing.');return}
            const current=this.cloudDrawing;if(current?.type!==drawing.type){this.showTheTip('Choose a matching '+drawing.type+' drawing to apply this shared drawing.');return}
            const settings=JSON.parse(JSON.stringify(drawing.settings)),chart=this.$refs.chart;
            delete settings.$uuid;delete settings.$selected;
            if(chart?.$props.ib){for(const key of Object.keys(settings))if(/^p\d+$/.test(key))settings[key][0]=chart.ti_map.t2i(settings[key][0]);if(settings.path)settings.path=settings.path.map(p=>[chart.ti_map.t2i(p[0]),p[1]])}
            this.onEditSettings({...settings,...metadata});
        },
        onEditSettings(changes) {
            // Merge directly into the datacube using the overlay's $uuid
            let dc = this.$props.data
            if (dc && this.editPopup.settings && this.editPopup.settings.$uuid) {
                dc.merge(`${this.editPopup.settings.$uuid}.settings`, changes)
            } else if (dc && this.editPopup.ovId) {
                // Fallback to path-based merge
                dc.merge(`${this.editPopup.ovId}.settings`, changes)
            }
            Object.assign(this.editPopup.settings, changes)
        },
        onDeleteTool() {
            let dc = this.$props.data
            let uuid = this.editPopup.settings && this.editPopup.settings.$uuid
            this.closeEditPopup()
            if (dc && uuid) {
                // Directly delete using the UUID we have from the popup
                dc.del(uuid)
                // Clean up selection state
                if (dc.data) {
                    this.$set(dc.data, 'selected', null)
                }
            } else {
                // Fallback to the system remove which uses data.selected
                this.custom_event({
                    event: 'remove-tool', args: []
                })
            }
        },
        onCloneTool() {
            const dc=this.$props.data,uuid=this.editPopup.settings?.$uuid;
            const side=(dc.data.onchart || []).some(o=>o.settings?.$uuid===uuid)?'onchart':'offchart';
            const original=dc.data[side].find(o=>o.settings?.$uuid===uuid);if(!original)return;
            const ov=JSON.parse(JSON.stringify(original));delete ov.id;delete ov.settings.$uuid;
            const interval=this.$refs.chart?.interval || 1;
            for(const key of Object.keys(ov.settings))if(/^p\d+$/.test(key))ov.settings[key][0]+=interval*3;
            if(ov.settings.path)ov.settings.path=ov.settings.path.map(p=>[p[0]+interval*3,p[1]]);
            ov.settings.$locked=false;const id=dc.add(side,ov);ov.settings.$uuid=`${id}-${Date.now()}`;
            dc.object_selected([[],ov.grid?.id || 0,'',ov.settings.$uuid]);this.showPopupForSelected();
        },
        closeEditPopup() {
            if (this._closePopupTimer) {
                clearTimeout(this._closePopupTimer)
                this._closePopupTimer = null
            }
            this.editPopup.visible = false
        },
        // --- Price alert lines (AlertLinesLayer) ---
        getChartLayout() {
            let chart = this.$refs.chart
            return chart && chart._layout
        },
        getChartCursor() {
            let chart = this.$refs.chart
            return chart && chart.cursor
        },
        onAlertAction(payload) {
            this.$emit('alert-action', payload)
        }
    }
}
</script>
<style>
/* Anit-boostrap tactix */
.tc *, ::after, ::before {
    box-sizing: content-box;
}
.tc img {
    vertical-align: initial;
}
.btn_on_large_screen {
    display: none;
}
.btn_on_all_screen {
    display: inline-flex;
}
@media only screen and (min-width: 767px) {
  .btn_on_large_screen {
    display: inline-flex;
  }
}
.watermark {
    pointer-events: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display:flex;
    align-items:center;
    justify-content:center;
    text-align: center;
    height: 30px;
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    font-size: 16px;
    opacity: 0.2;
    filter:alpha(opacity=60);
}

@media only screen and (min-width: 767px) {
    .watermark {
        font-size: 80px !important;
    }
}
.control_bar {
    pointer-events: none;
    position: absolute;
    bottom: 60px;
    left: 50%;
    transform: translateX(-50%);
    height: 30px;
    user-select: none;
}
.chart_logo_wrapper {
    position: absolute;
    bottom: 60px;
    left: 60px;
    height: 30px;
    user-select: none;
    z-index: 2;
}
.spacer {
    padding: 5px;
}

</style>
